import { Check, X } from "lucide-react";

export type TaskProgressState = "pending" | "correct" | "wrong";

export type TaskStatus = {
  english: TaskProgressState;
  telugu: TaskProgressState;
  drawing: TaskProgressState;
};

type Props = {
  taskStatus: TaskStatus;
};

const TASKS = [
  { key: "english", label: "English" },
  { key: "telugu", label: "Telugu" },
  { key: "drawing", label: "Drawing" },
] as const;

const TaskProgress = ({ taskStatus }: Props) => {
  return (
    <div className="mb-1 flex justify-center" aria-label="Practice progress">
      <div className="flex items-center gap-1.5 rounded-full bg-[#f5dcff] px-1.5 py-0.5 shadow-sm">
        {TASKS.map(({ key, label }) => {
          const state = taskStatus[key];
          const isCorrect = state === "correct";
          const isWrong = state === "wrong";

          return (
            <div
              key={key}
              className="flex items-center gap-0.5 text-[11px] font-extrabold leading-none text-[#b83df3]"
            >
              <span
                className={`flex h-4 w-4 items-center justify-center rounded-full border-2 ${
                  isCorrect
                    ? "border-[#a8d9ae] bg-[#a8d9ae] text-white"
                    : isWrong
                    ? "border-[#ff9c9c] bg-[#ff9c9c] text-white"
                    : "border-[#ee54ff] bg-white/20"
                }`}
              >
                {isCorrect && <Check className="h-3 w-3 stroke-[4]" />}
                {isWrong && <X className="h-3 w-3 stroke-[4]" />}
              </span>
              {label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TaskProgress;
